import type { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './analysis-tile.module.scss';

interface AnalysisTileProps {
  /** The tile heading, e.g. "Shared Assets". */
  label: string;
  /** The primary value (already formatted). */
  value: ReactNode;
  /** Optional secondary line under the value. */
  sub?: ReactNode;
  /** Colors the value: success green / error red / default. */
  tone?: 'positive' | 'negative' | 'neutral';
  /** Renders the value muted (used for the deferred Avg-Price / EUR tile). */
  muted?: boolean;
}

// One analysis summary tile: a label, a bold value, and an optional sub-line.
// Generic and domain-free — the panel maps analysis data to these props.
export function AnalysisTile({
  label,
  value,
  sub,
  tone = 'neutral',
  muted = false,
}: AnalysisTileProps) {
  return (
    <div className={styles.tile}>
      <div className={styles.label}>{label}</div>
      <div
        className={classNames(styles.value, {
          [styles.positive]: !muted && tone === 'positive',
          [styles.negative]: !muted && tone === 'negative',
          [styles.muted]: muted,
        })}
      >
        {value}
      </div>
      {sub !== undefined && sub !== null && (
        <div className={styles.sub}>{sub}</div>
      )}
    </div>
  );
}
